import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'

interface Props {
  buildId: BuildId
}
export const useQueryDependenciesTotalCount = (props: Props) =>
  restApi.endpoints.getBuildProperties.useQuery(
    {
      buildLocator: `id:${props.buildId}`,
      fields: `resultingProperties(count,$locator:(name:(value:(^dep\\..*),matchType:matches,ignoreCase:true)))`,
    },
    {
      selectFromResult: ({data}) => ({
        count: data?.resultingProperties?.count ?? 0,
      }),
    },
  )
